<template>
  <div>
    <div>
      <div
        class="card"
        :id="'popover-target-' + bloque.id_bloque"
      >
        <div class="image-container">

          <img
            v-if="bloque.imagen_url"
            :src="bloque.imagen_url"
            class="card-img-top"
            alt="bloque imagen"
            @error="bloque.imagen_url = ''"
          />
          <div v-if="!bloque.imagen_url" class="no-image">
            Sin imagen
          </div>
          <div class="overlay-text">
            <p>{{bloque.modalidad}}</p>
          </div>
        </div>
        <div class="card-body">
          <h4 class="card-title font-bold">
            <strong>
              {{ bloque.nombre_bloque }}
            </strong>
          </h4>
          <p class="card-text">
            {{ bloque.descripcion }}
          </p>
          <p>
            <div class="rating-container">
              <star-rating
                read-only="true"
                :rating="bloque.rating"
                :show-rating="false"
                star-size="25"
                border-color="#FF0"
                increment="0.5"
              />
              <span class="text-muted ml-2">{{bloque.rating}}/5</span>
            </div>
          </p>

          <span class="precio-container">
            $ {{ bloque.precio }} MXN
          </span>
        </div>
        <div class="card-footer">
          <span>{{ bloque.total_horas }} {{$t('page.general.horas')}}</span>
          <span>{{ bloque.temas.length }} {{$t('page.general.modulos')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
export default {
  components: {
    StarRating
  },
  props: ['bloque'],
  data() {
    return {
      bloqueSelected: {},
      precioTotal: 0,
    };
  },
  methods: {
    abrirModal(modalName) {
      this.$emit('modal-opened', this.bloque);
    },
    irAShoppingCart() {
      this.$router.push({
        name: "Shopping_Cart",
        params: {
          items: [
            this.bloque.temas[0],
            this.bloque.temas[1],
          ]
        }
      });
    },
  },
  created() {
  },
};
</script>

<style scoped>
.card-body {
  padding: 1rem;
  cursor: pointer;
}
.image-container {
  width: 100%;
  position: relative;
  cursor: pointer;
}
.image-container {
  img {
    width: 100%;
  }
}

.card-img-top {
  height: auto;
  height: 12rem;
  width: 100%;
  object-fit: cover;
}
.card {
  width: 90%;
}

.overlay-text {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  text-align: center;
  padding: 5px;
  height: 30px;
}
.rating-container {
  display: flex;
  align-items: baseline;
}
.rating-container span {
  font-size: 15px;
}
.precio-container {
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: none;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  background-color: white;
  cursor: pointer;
}
.card-text {
  height: 4rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  text-overflow: ellipsis;
}
.no-image {
  height: 12rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  text-transform: none;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/e-commerce/bloque_card_ecommerce.vue